module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-3-3eeae9755634de10ce015b6a85bcc8e3.jpg";